module.exports = __webpack_public_path__ + "img/out-for-delivery.353ead27.svg";